module.exports = __webpack_public_path__ + "img/13_30.4acc6794.png";